export interface IReportsRow {
  evidenceSource: string;
  id: number;
  documentId: string;
  fileName: string;
  path: string;
  alphaCode: string;
  exceptionCategory: string;
  hosted: number;
  batchNumberSuppressed: string | number;
  total: number;
  custodianDisplayName: string;
  dataset: string;
  documentKind: string;
  documentFileType: string;
  mediaID: number;
  actionable: number;
  custodianId: number;
  documentFileName: string;
  documentFilePath: string;
  exceptionCategoryId: number;
  mediaId: number;
  suppressed: number;
}

export interface ReportData {
  title: string;
  description: string;
  userName: string;
  total?: number;
  type?: string;
}

export const ReportTypes = {
  CORRUPTED_ACTIONABLE: 'Corrupted - Actionable',
  ENCRYPTED: 'Encrypted',
  NON_SEARCHABLE_PDFS: 'Non-Searchable PDFs',
  CORRECTED_BAD_EXTENSIONS: 'Corrected Bad Extensions',
  RECOVERED_DELETED_EMAILS: 'Recovered Deleted Emails',
  CORRUPTED_NON_ACTIONABLE: 'Corrupted Non-Actionable',
  EMPTY_ZERO_BYTE_FILES: 'Empty Zero Byte Files',
  PROBLEMATIC_TEXT: 'Problematic Text',
  UNRECOGNIZED_FILE: 'Unrecognized File',
  UNSUPPORTED_FILE: 'Unsupported File',
};
